import { useEffect, useState } from 'react'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { captureReferral, REFERRAL_FALLBACK_PATH as FALLBACK_PATH, validReferralCode } from 'src/utils/referral'

const INVITED_DELAY_MS = 1500

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 50vh;
    padding: 0 16px;
    text-align: center;
`

const Heading = styled.h1`
    font-size: 28px;
    font-weight: 700;
`

const Subheading = styled.p`
    color: rgba(255, 255, 255, 0.6);
`

/** Personal affiliate link: store the code, say who sent them, then go to the program's landing page. */
const ReferralLink = ({ match }: RouteComponentProps<{ referralCode: string }>) => {
    const history = useHistory()
    const [displayName, setDisplayName] = useState<string | null>(null)

    useEffect(() => {
        // The router has already decoded the param
        const code = validReferralCode(match.params.referralCode)
        let timer: ReturnType<typeof setTimeout> | undefined
        let cancelled = false

        const go = (path: string, delay = 0) => {
            timer = setTimeout(() => !cancelled && history.replace(path), delay)
        }

        if (!code) {
            go(FALLBACK_PATH)
            return
        }

        captureReferral(code)
            .then((result) => {
                if (cancelled) return
                if (!result) return go(FALLBACK_PATH)
                setDisplayName(result.displayName)
                go(result.redirectTo || FALLBACK_PATH, INVITED_DELAY_MS)
            })
            .catch(() => go(FALLBACK_PATH))

        return () => {
            cancelled = true
            if (timer) clearTimeout(timer)
        }
    }, [match.params.referralCode, history])

    return (
        <Container>
            {displayName ? (
                <>
                    <Heading>Invited by {displayName}</Heading>
                    <Subheading>Taking you to SwiftSole…</Subheading>
                </>
            ) : (
                <Subheading>Loading…</Subheading>
            )}
        </Container>
    )
}

export default ReferralLink
